$('.slider').slick({
  dots: false,
  arrows: true,
  infinite: true,
  speed: 1800,
  fade: true,
  autoplay: true,
  autoplaySpeed: 2000,
  pauseOnHover: false
});


$('.responsive-slider').each (function(){

  const numSlides = $(this).find('.responsive-slider__slide').length;

  const slickOptions = {
    dots: false,
    infinite: true,
    speed: 300,
    rows: (numSlides > 5 ? 2 : 1),
    slidesToShow: (numSlides > 2 ? 5 : 2),
    slidesToScroll: 5,
    responsive: [
      {
        breakpoint: 1550,
        settings: {
          rows: (numSlides > 4 ? 2 : 1),
          slidesToShow: (numSlides > 2 ? 6 : 2),
          slidesToScroll: 4
        }
      },
      {
        breakpoint: 1390,
        settings: {
          rows: (numSlides > 3 ? 2 : 1),
          slidesToShow: (numSlides > 2 ? 4 : 2),
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 1000,
        settings: {
          rows: (numSlides > 2 ? 2 : 1),
          slidesToShow: (numSlides > 2 ? 2 : 1),
          slidesToScroll: (numSlides > 2 ? 2 : 1)
        }
      }
    ]
  };

  $(this).slick(slickOptions);

  //check if there are more than 3 elements
  if (numSlides < 3) {
    //if so get the last 2 elements and add the class
    $(this).addClass("two-item-slider");
  }

  //check if there are more than 5 elements
  if (numSlides < 6) {
    //if so get the last 2 elements and add the class
    $(this).addClass("single-row-slider");
  }

  // $(this).addClass("single-row-slider");

})



$('.cutoff-slider').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  centerMode: false,
  responsive: [
    {
      breakpoint: 1700,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 1000,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
});

/* Slick needs no get Reinitialized on window Resize after it was destroyed */
$(window).on('load resize orientationchange', function() {
  $('.cutoff-slider').each(function(){
    var $slider = $(this);
    /* Initializes a slick cutoff-slider only on larger screens */
    // slick on mobile
    if ($(window).width() < 768) {
        if ($slider.hasClass('slick-initialized')) {
            $slider.slick('unslick');
        }
    }
    else{
      if (!$slider.hasClass('slick-initialized')) {
        $slider.slick({
          dots: false,
          infinite: true,
          speed: 300,
          slidesToShow: 4,
          slidesToScroll: 1,
          centerMode: false,
          responsive: [
            {
              breakpoint: 1700,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 1000,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            }
          ]
        });
      }
    }
  });
});






